import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
const checkoutUrl = 'https://rhythmic-coach-ready.impultienda.ar/checkout';
export function CTAButton({
  children,
  href = checkoutUrl,
  className = ''
}: CTAButtonProps) {
  return <a href={href} target="_blank" rel="noopener noreferrer" className={`block w-full text-center cursor-pointer px-4 py-3 sm:py-4 font-heading font-bold text-base sm:text-lg uppercase tracking-wide rounded-md bg-brand-pink text-white hover:bg-[#D875A1] hover:scale-[1.02] transition-all duration-200 border-b-4 border-[#B95D87] active:border-b-0 active:translate-y-1 shadow-[0_5px_14px_rgba(233,140,179,0.45)] ${className}`} data-id="element-33" data-mp="2fzl9pcll48wv">
      {children}
    </a>;
}